import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Terms() {
  return (
    <>
      <Nav />
      <main
        data-testid="terms-page"
        className="mx-auto max-w-3xl px-6 py-14 sm:py-20"
      >
        <Link
          to="/"
          className="text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          ← Back
        </Link>
        <h1 className="font-serif-display mt-6 text-5xl">Terms</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Last updated: February 2026
        </p>

        <section className="mt-10 space-y-6 text-[15px] leading-7 text-foreground/90">
          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">AI disclosure</h2>
            <p className="mt-3">
              Call God is an AI-generated spiritual reflection voice. The voice can
              speak in a sacred, sometimes scripture-adjacent style, but it is not
              literal divine authority, not omniscient, and not infallible. Every
              response you hear is generated by a language model.
            </p>
          </div>

          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">Not a substitute</h2>
            <ul className="mt-3 list-disc space-y-2 pl-5">
              <li>
                Call God is <strong>not therapy</strong> and is not a substitute for
                licensed mental-health care.
              </li>
              <li>
                Call God is <strong>not clergy</strong> and is not a substitute for
                pastoral or spiritual counsel from a real human leader.
              </li>
              <li>
                Call God is <strong>not medical, legal, or financial advice</strong>.
              </li>
              <li>
                Call God is <strong>not an emergency service</strong>.
              </li>
            </ul>
          </div>

          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">If you are in crisis</h2>
            <p className="mt-3">
              If you are in immediate danger, please contact your local emergency
              services right now. In the United States, call or text <strong>988</strong>
              {" "}to reach the Suicide and Crisis Lifeline.
            </p>
          </div>

          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">Acceptable use</h2>
            <p className="mt-3">
              Be kind to yourself and to others on this line. Don’t use Call God to
              produce content that harms a person, attempts to impersonate a specific
              real individual, or violates local law.
            </p>
          </div>

          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">Service is provided “as is”</h2>
            <p className="mt-3">
              The service is offered without warranty of any kind. We try our best to
              keep it tender and available, but generation can be wrong, surprising,
              or unavailable. By using the service you accept that risk.
            </p>
          </div>

          <p className="text-sm text-muted-foreground">
            See also our <Link to="/privacy" className="underline">privacy policy</Link>.
          </p>
        </section>
      </main>
      <Footer />
    </>
  );
}
